import { useContext } from "react"

import History from "@/context/HistoryContext"

export const useHistory = () => {
  return useContext(History)
}

export default useHistory
